var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 424,
    viewBox: "0 0 459 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Polygon 6",
    filter: "url(#filter0_f_294_27948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.102 132.058L326.339 291.686H131.866L229.102 132.058Z",
    fill: "#C82D47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_294_27948",
    x: 0.0194092,
    y: 0.212189,
    width: 458.165,
    height: 423.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.9231,
    result: "effect1_foregroundBlur_294_27948"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedGlow);
export default __webpack_public_path__ + "static/media/redGlow.b71e5fb0fea7ebd85083eb8c24b61659.svg";
export { ForwardRef as ReactComponent };